module.exports = __webpack_public_path__ + "img/harmony_feature_01.647649bc.jpg";